import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

const ENTITY_TYPE = 'TENANT' as const;

export type LabelsOverrideRequest = {
	entityId: string;
	entityType: typeof ENTITY_TYPE;
	newValue: ConfigurationLabel[];
	productId: string;
};

export { ENTITY_TYPE };
